import { useQuery } from '@tanstack/react-query';

// Services
import { getMyMediaTree } from './mediaTreeService';

/**
 * @description Hook to get a folder media tree.
 * @param {object} urlParams - The URL parameters to use for filtering the media list.
 * @param {string} [urlParams.path] - "root" or the ID of the folder to fetch.
 * @param {object} options QueryOptions
 * @returns {import('@tanstack/react-query').UseQueryResult<
 * ContentType, Error>}
 */
export const useMediaTree = (urlParams, options) => useQuery(
  ['mediaTree', urlParams],
  () => getMyMediaTree(urlParams),
  { ...options },
);
